function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBriefing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.47,319a4,4,0,0,1-2.6-7l37.8-32.35a4,4,0,1,1,5.2,6.08l-37.8,32.35A4,4,0,0,1,74.47,319Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.92,288.65a4,4,0,0,1-2.6-7l37.35-32a4,4,0,0,1,5.2,6.08l-37.35,32A4,4,0,0,1,74.92,288.65Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.54,316.47a4,4,0,0,1-2.61-7l45.82-39.21a4,4,0,1,1,5.2,6.08l-45.81,39.2A4,4,0,0,1,112.54,316.47Z",
    style: {
      fill: "#2ba6de"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.22,127.6c0-.1,0-.2,0-.3a1.81,1.81,0,0,0,0-.23,1,1,0,0,0,0-.17,1.82,1.82,0,0,0,0-.33,1.85,1.85,0,0,0,0-.23.71.71,0,0,0,0-.14l0-.17-.06-.31,0-.1a.78.78,0,0,0-.05-.14.45.45,0,0,0,0-.11.54.54,0,0,0,0-.11,1.45,1.45,0,0,0-.11-.26l-.1-.2,0,0-.09-.17-.18-.25-.07-.11-.07-.07-.1-.13-.15-.14-.15-.15-.12-.11,0,0-.09-.06c-.07-.06-.14-.1-.21-.15l-.26-.17-.15-.08-.21-.1-.3-.12-.2-.06-.17,0a3.43,3.43,0,0,0-.34-.06l-.2,0-.14,0a1,1,0,0,1-.17,0h-.31a.27.27,0,0,0-.09,0l-.15,0-.23,0-.31.06-.21.07-.14,0L92.78,185.07a4,4,0,0,0,.08,7.56l31.79,10.59a4,4,0,0,0,1.26.2,4,4,0,0,0,1.26-7.79l-20.77-6.92,126.1-45L138,201a4,4,0,0,0-1.91,3.08l-4.88,56s0,0,0,0,0,.16,0,.24a2.77,2.77,0,0,0,0,.5c0,.09,0,.18,0,.27s.06.3.1.45.07.18.11.28a2.83,2.83,0,0,0,.17.4l.15.26a2.7,2.7,0,0,0,.27.39l.1.15.08.06a3.71,3.71,0,0,0,.5.47l.09.08a4,4,0,0,0,.67.39l.25.09a2,2,0,0,0,.34.13l.18,0,.18,0a3.81,3.81,0,0,0,.74.08,3.47,3.47,0,0,0,.64-.06l.18,0a3.54,3.54,0,0,0,.44-.11l.2-.08a3.1,3.1,0,0,0,.45-.21l.14-.07a4.7,4.7,0,0,0,.53-.38l0,0,29-25.11a4,4,0,0,0-5.24-6L148,244.1l13-25.62,56.46,45.06a4,4,0,0,0,6.26-1.77l48.42-133.69s0-.06,0-.08,0-.12.05-.18Zm-128.3,79.14L214.49,164l-57.36,45.15a4.11,4.11,0,0,0-.6.58l-.07.11a4.29,4.29,0,0,0-.39.59l0,0-15,29.66ZM218,253.8l-52-41.49,93.76-73.79Z",
    style: {
      fill: "#9c9fa3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74,194.67a3,3,0,0,1-2.83-2l-4.14-11.82L274,176.71a3,3,0,0,1,0-5.67l11.81-4.13,4.14-11.82a3,3,0,0,1,2.83-2h0a3,3,0,0,1,2.83,2l4.13,11.82L311.52,171a3,3,0,0,1,0,5.67l-11.82,4.13-4.13,11.82A3,3,0,0,1,292.74,194.67ZM284,173.87l5.09,1.78a3,3,0,0,1,1.84,1.84l1.78,5.09,1.78-5.09a3,3,0,0,1,1.84-1.84l5.08-1.78-5.08-1.78a3,3,0,0,1-1.84-1.84l-1.78-5.08L291,170.25a3,3,0,0,1-1.84,1.84Z",
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,106.55a3,3,0,0,1-2.84-2L244.8,92.72,233,88.59a3,3,0,0,1,0-5.67l11.82-4.13L248.93,67a3,3,0,0,1,2.84-2h0a3,3,0,0,1,2.83,2l4.13,11.82,11.82,4.13a3,3,0,0,1,0,5.67l-11.82,4.13-4.13,11.82A3,3,0,0,1,251.77,106.55Zm-8.71-20.79,5.09,1.77A3,3,0,0,1,250,89.38l1.78,5.08,1.77-5.08a3,3,0,0,1,1.85-1.85l5.08-1.77L255.39,84a3,3,0,0,1-1.85-1.84l-1.77-5.09L250,82.14A3,3,0,0,1,248.15,84Z",
    style: {
      fill: "#f8b417"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.47,
    cy: 120,
    r: 4,
    style: {
      fill: "#f0b633"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.4,
    cy: 125.91,
    r: 4,
    style: {
      fill: "#f0b633"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.25,
    cy: 217.83,
    r: 4,
    style: {
      fill: "#f0b633"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBriefing);
export default __webpack_public_path__ + "static/media/send-briefing.283cd09020e2a2be239040ecb15e4169.svg";
export { ForwardRef as ReactComponent };